var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"le-checkbox"},[_vm._t("default"),_c('input',{ref:"lecheckbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":_vm.updateData}}),_c('span',{staticClass:"checkmark"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }